<form [formGroup]="form" (ngSubmit)="form.valid && submit()">
  <div mat-dialog-title>
    <h1>{{data.title}}</h1>
    <button mat-icon-button [mat-dialog-close]="false" class="close">
      <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-label>{{data.placeholder}}</mat-label>
      <input matInput formControlName="input">
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="false" color="primary">Cancel</button>
    <button mat-raised-button type="submit" color="accent" [disabled]="form.invalid">Confirm</button>
  </mat-dialog-actions>
</form>
